"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DefaultModalClose = _interopRequireDefault(require("./DefaultModalClose"));

var _ModalScreen = _interopRequireDefault(require("./ModalScreen"));

var _ModalBody = _interopRequireDefault(require("./ModalBody"));

var _propTypes2 = require("../propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Modal provides ability to wrap content in an element that can be
 * animated on and off the screen.
 *
 * NOTE: Modal is dependent on many default Tailwind classes, e.g.,
 * flex, position, opacity, pointer-events, and others. It doesn't use
 * classes that are likely to be project-specific, e.g., colors and spacing.
 *
 */


var Modal = function Modal(_ref) {
  var _classNames;

  var showing = _ref.showing,
      setShowing = _ref.setShowing,
      children = _ref.children,
      ModalClose = _ref.ModalClose,
      _className = _ref.className,
      showingClassName = _ref.showingClassName,
      _style = _ref.style,
      showingStyle = _ref.showingStyle,
      onShowing = _ref.onShowing,
      onHiding = _ref.onHiding,
      showingAnimation = _ref.showingAnimation,
      hidingAnimation = _ref.hidingAnimation,
      verticalPosition = _ref.verticalPosition,
      horizontalPosition = _ref.horizontalPosition,
      fullScreen = _ref.fullScreen;
  var el = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      shownOnce = _useState2[0],
      setShownOnce = _useState2[1];

  (0, _react.useEffect)(function () {
    if (showing && !shownOnce) {
      setShownOnce(true);
    }

    if (showing) {
      if (showingAnimation) {
        showingAnimation(el.current);
      }

      if (onShowing) {
        onShowing();
      }
    } // Don't run hiding animation or callback until modal
    // has been shown at least once. This prevents these funcs
    // from firing when the Modal is initially rendered as hidden,
    // which is the most common use case.


    if (!showing && shownOnce) {
      if (hidingAnimation) {
        hidingAnimation(el.current);
      }

      if (onHiding) {
        onHiding();
      }
    }
  }, [showing]);
  var className = (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, "CosmicModal fixed flex flex-col w-full justify-".concat(verticalPosition, " items-").concat(horizontalPosition), true), _defineProperty(_classNames, "".concat(_className), !!_className), _defineProperty(_classNames, "".concat(showingClassName), !!showingClassName), _defineProperty(_classNames, "pointer-events-auto", showing), _defineProperty(_classNames, "pointer-events-none", !showing), _defineProperty(_classNames, "opacity-100", showing && !showingAnimation), _defineProperty(_classNames, "opacity-0", !shownOnce || !showing && !hidingAnimation), _classNames));

  var style = _objectSpread({}, _style, {}, showing ? showingStyle : {}, {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }); // Pass close handler into the ModalClose component


  var Close = function Close() {
    return _react.default.createElement(ModalClose, {
      onClick: function onClick() {
        return setShowing(false);
      }
    });
  };

  return _react.default.createElement("div", {
    ref: el,
    className: className,
    style: style
  }, _react.default.createElement(_ModalScreen.default, {
    onClick: function onClick() {
      return setShowing(false);
    }
  }), _react.default.createElement(_ModalBody.default, {
    Close: Close,
    fullScreen: fullScreen
  }, children));
};

Modal.propTypes = {
  showing: _propTypes.default.bool.isRequired,
  setShowing: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired,

  /** React component to render in the Close slot, e.g., an SVG "X" icon.
   * The component will need to receive an `onClick` function as a prop, which
   * will be passed the handler that closes the modal  */
  ModalClose: _propTypes.default.func,
  className: _propTypes.default.string,
  showingClassName: _propTypes.default.string,
  style: _propTypes2.styleProps,
  showingStyle: _propTypes2.styleProps,

  /** Callback when modal shows */
  onShowing: _propTypes.default.func,

  /** Callback when modal hides */
  onHiding: _propTypes.default.func,

  /** A function to show the modal (e.g., gsap animation).
   * Receives the modal HTML element as an argument. Should be
   * used lieu of `showingClassname` or `showingStyle`  */
  showingAnimation: _propTypes.default.func,

  /** A function to hide the modal (e.g., gsap animation).
   * Receives the modal HTML element as an argument. */
  hidingAnimation: _propTypes.default.func,

  /** Flex-box orientation of the modal in the viewport */
  verticalPosition: _propTypes.default.oneOf(["start", "center", "end"]),
  horizontalPosition: _propTypes.default.oneOf(["start", "center", "end"]),

  /** If the modal should be full-screen */
  fullScreen: _propTypes.default.bool
};
Modal.defaultProps = {
  ModalClose: _DefaultModalClose.default,
  className: "",
  showingClassName: "",
  style: {},
  showingStyle: {},
  onShowing: null,
  onHiding: null,
  showingAnimation: null,
  hidingAnimation: null,
  verticalPosition: "center",
  horizontalPosition: "center",
  fullScreen: false
};
var _default = Modal;
exports.default = _default;